var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Caption, Datepicker, NativeDatepicker, Trigger } from './components';
import { getDateStringFromProp, preferNativeDatepicker } from './helpers';
import { DateInputContainer } from './styles';
/**
 * Somehow TypeScript has problems with the combination of ForwardRefExoticComponent and adding DateInputType. With a
 * FunctionComponent there is no problem. This workaround fixes it. First make them partial (DateInputType) and then
 * when exporting, assigning it to a new const with the propper type (without the partial).
 */
export const InnerDateInput = forwardRef(
// eslint-disable-next-line prefer-arrow-callback
function DateInputWithRef(_a, ref) {
    var { forceCustomDatepicker = false, min, max } = _a, props = __rest(_a, ["forceCustomDatepicker", "min", "max"]);
    const native = preferNativeDatepicker() && !forceCustomDatepicker;
    const minDate = getDateStringFromProp(min);
    const maxDate = getDateStringFromProp(max);
    if (native) {
        return React.createElement(NativeDatepicker, Object.assign({ min: minDate, max: maxDate, ref: ref }, props));
    }
    return React.createElement(Datepicker, Object.assign({ min: minDate, max: maxDate, ref: ref }, props));
});
// These components are made available for the FormFieldDatepicker component
InnerDateInput.Caption = Caption;
InnerDateInput.Container = DateInputContainer;
InnerDateInput.Trigger = Trigger;
export const DateInput = InnerDateInput;
//# sourceMappingURL=DateInput.js.map